/**
 * Module dependencies.
 */

import React from 'react';
import * as Icons from './index';

/**
 * Icon options with their corresponding numbers.
 */

export const DrugIcons = [
  { name: 'Ampoule', number: 1 },
  { name: 'Antiseptic', number: 2 },
  { name: 'Asthma Inhaler', number: 3 },
  { name: 'Bandage', number: 4 },
  { name: 'Capsules', number: 5 },
  { name: 'Cream', number: 6 },
  { name: 'Drink Effervescent', number: 7 },
  { name: 'Drugs', number: 8 },
  { name: 'Effervescent', number: 9 },
  { name: 'Eye Drop', number: 10 },
  { name: 'Eye Dropper', number: 11 },
  { name: 'Herbal Medicine', number: 12 },
  { name: 'Herbal Mortar', number: 13 },
  { name: 'Iodine', number: 14 },
  { name: 'Lotion', number: 15 },
  { name: 'Nasal Spray', number: 16 },
  { name: 'Pills', number: 17 },
  { name: 'Ointment', number: 18 },
  { name: 'Pharmacy', number: 19 },
  { name: 'Plaster', number: 20 },
  { name: 'Spray', number: 21 },
  { name: 'Suppository', number: 22 },
  { name: 'Syrup', number: 23 },
  { name: 'Vaccine', number: 24 }
];

/**
 * `Props` type.
 */

type Props = {
  iconNumber: number;
  size?: number;
  color?: string;
  className?: string;
};

/**
 * Export `DrugIcon` component.
 */

export function DrugIcon({
  iconNumber,
  size = 24,
  color = 'currentColor',
  className
}: Props): React.ReactElement | null {
  const IconComponent = Icons[`DrugIcon${iconNumber}` as keyof typeof Icons];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent className={className} height={size} style={{ color }} width={size} />;
}
